import React from "react";
import {IQuestion} from "../../../interfaces/IQuestion";

function QuizHeader(p: IQuestion) {
    return(
        <div className={'quiz-header'}>
            <div>
                <div className={(p.customLabel === null || p.customLabel === "") ? 'quiz-label-blank' : 'quiz-label'}>
                    {(p.customLabel !== null) ? p.customLabel : 'QUIZ'}
                </div>
                <div className={'question'}>
                    {p.question}
                </div>
            </div>
        </div>
    )
}

export default QuizHeader
